import { useState, useEffect } from "react";
import axiosInstance from "../../api/axios";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[-~!@#$%^&*()_?]).{8,}$/;

// Contact me page
const RegistrationForm = () => {
  const [email, setEmail] = useState("");
  const [validEmail, setValidEmail] = useState(false);

  const [password, setPassword] = useState("");
  const [validPassword, setValidPassword] = useState(false);

  const [confirmPassword, setConfirmPassword] = useState("");
  const [validConfirmPassword, setValidConfirmPassword] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const normalizedEmail = email.trim();
    setValidEmail(EMAIL_REGEX.test(normalizedEmail));
  }, [email]);

  useEffect(() => {
    setValidPassword(PASSWORD_REGEX.test(password));
    setValidConfirmPassword(password === confirmPassword);
  }, [password, confirmPassword]);

  useEffect(() => {
    setErrorMessage("");
  }, [email, password, confirmPassword]);

  const submitForm = async (e) => {
    e.preventDefault();
    const normalizedEmail = email.trim();

    if (!EMAIL_REGEX.test(normalizedEmail) || !PASSWORD_REGEX.test(password)) {
      setErrorMessage("Invalid Entry");
      return;
    }

    try {
      await axiosInstance.post("/api/auth/register", {
        email: normalizedEmail,
        password,
      });
      setSuccessMessage(
        "Verification Email Sent. Check Spam folder if email is not visible."
      );
    } catch (err) {
      if (err.response?.data?.message === "User with this email already exists")
        setErrorMessage("User with this email already exists");
      else setErrorMessage(err.response?.data?.message || "Registration Failed");
    }
  };

  return (
    <div className="complete-log-form">
      <form className="auth-form" onSubmit={submitForm}>
        <p className="reg-subtitle">
          Your boarding pass starts with a verified email address.
        </p>
        <div className="auth-form-inner">
          {successMessage && <p className="error-message">{successMessage}</p>}
          {errorMessage && <p className="error-message">{errorMessage}</p>}
          {email && !validEmail && (
            <p className="error-message">Must be a valid email address</p>
          )}
          <div className="form-field">
            <label htmlFor="email">Email address</label>
            <input
              type="email"
              placeholder="you@example.com"
              id="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          {password && !validPassword && (
            <p className="error-message">
              Password must have at least 8 characters, 1 number, and 1 special
              character
            </p>
          )}
          <div className="form-field">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              className="auth-form-password"
              placeholder="8+ characters"
              id="password"
              autoComplete="new-password"
              maxLength={72}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {password && confirmPassword && !validConfirmPassword && (
            <p className="error-message">This field must match the password</p>
          )}

          <div className="form-field">
            <label htmlFor="confirmPassword">Confirm password</label>
            <input
              type="password"
              placeholder="Repeat your password"
              className="auth-form-password"
              id="confirmPassword"
              autoComplete="new-password"
              maxLength={72}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <p className="auth-meta">
            <a className="auth-meta" href="/login">
              Already have an account?
            </a>
          </p>

          <div className="auth-form__lower">
            {!successMessage && (
              <button
                type="submit"
                className="button"
                placeid="auth-button"
                disabled={
                  !validEmail || !validPassword || !validConfirmPassword
                }
              >
                Get boarding pass
              </button>
            )}
            {successMessage && (
              <a href="/login" className="auth-button-link">
                Return to login
              </a>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default RegistrationForm;
